import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeFeedComponent } from './home-feed/home-feed.component';
import { HomeFeedSectionComponent } from './home-feed-section/home-feed-section.component';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { CarouselWrapperComponentLegacy } from '@brightside/brightside-ui/carousel';

@NgModule({
  imports: [CommonModule, RouterLink, TranslateModule, BrightsideUiModule, SharedDesktopModule, CarouselWrapperComponentLegacy],
  declarations: [HomeFeedComponent, HomeFeedSectionComponent],
  exports: [HomeFeedComponent],
})
export class DesktopFeatureHomeFeedModule {}
